import { render, staticRenderFns } from "./DocumentoDettaglio.vue?vue&type=template&id=08980a20&"
import script from "./DocumentoDettaglio.vue?vue&type=script&lang=js&"
export * from "./DocumentoDettaglio.vue?vue&type=script&lang=js&"
import style0 from "./DocumentoDettaglio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports